export const NakdanStyle = {
  Mobile: window.innerWidth < 992,
  Desktop: window.innerWidth >= 992
}

export const MobileVsDesktopConfig = {
  DOCUMENT_SETTINGS_PANE: NakdanStyle.Desktop,
  ALLOW_DOCUMENT_LOAD: NakdanStyle.Desktop,
  RESULTS_TOOLS: {
    BOTTOM: NakdanStyle.Desktop,
    HEADER: NakdanStyle.Mobile
  },
  HITTING_WORD_OPENS_OPTIONS: NakdanStyle.Mobile,
  SHOW_MARGINS_WITH_PANES: NakdanStyle.Desktop
}
